import request from '@/utils/request'

/**
 * 商品导入
 * @param {Object} data 导入数据
 * @returns {Promise} 返回导入结果
 */
export function uploadProductImport(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetImport',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error.response.data)
    })
  })
}